import React, { useEffect } from 'react';

import { useReleasePurchaseFormContext } from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesPurchaseProvider';
import { DefaultRouteTabs, SaveButton } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import { usePurchaseUpdate } from '@/core/domain/purchase/Purchase.hooks';
import { PurchaseUpdateRequest } from '@/core/domain/purchase/Purchase.types';
import Authorities from '@/types/Authority';
import { useIntl } from 'react-intl';
import PurchaseDataFreightForm from '@/components/Movements/Purchases/PurchaseDetails/PurchaseDataFreightForm';
import { Form, Skeleton } from 'antd';
import PurchasesButtonsRepeated from '@/components/Movements/Purchases/PurchasesButtonsRepeated';
import purchaseValidationTabs from '@/utils/functions/purchase/purchaseValidationTabs';
import { hasPermissions } from '@/utils/functions/hasPermissions';

const PurchaseDataFreightPage: React.FC<PageProps> = ({ route }) => {
  const intl = useIntl();
  const { purchaseId, purchase, loadingPurchase } =
    useReleasePurchaseFormContext();

  const [form] = Form.useForm<PurchaseUpdateRequest>();

  const { mutateAsync, isLoading } = usePurchaseUpdate();

  useEffect(() => {
    if (purchase) {
      form.setFieldsValue({ ...purchase });
    }
  }, [purchase]);

  const handleSubmit = async () => {
    const values = await form.validateFields();

    const obj: PurchaseUpdateRequest = {
      ...purchase,
      ...values,
    };

    await mutateAsync(obj);
  };

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      route={purchaseValidationTabs(route, purchase)}
      baseKey={purchaseId}
      basePath={`/app/movements/purchases/purchasesReleases/${purchaseId}`}
      extra={
        <>
          <SaveButton
            type="primary"
            block
            disabled={
              !hasPermissions([Authorities.MOVIMENTATION_PURCHASE_EDIT]) ||
              purchase?.boschMigration
            }
            loading={isLoading}
            onClick={handleSubmit}
          >
            {intl.formatMessage({ id: 'commons.entity.save' })}
          </SaveButton>
        </>
      }
    >
      <Skeleton loading={loadingPurchase}>
        <PurchaseDataFreightForm form={form} />

        <PurchasesButtonsRepeated purchase={purchase} />
      </Skeleton>
    </DefaultRouteTabs>
  );
};

export default PurchaseDataFreightPage;
